import { AppService, APP_MODE } from 'src/app/app.service';
import { HttpClient } from '@angular/common/http';
import { ApiService } from 'src/app/api.service';
import { UnitOfWorkOfflineDao } from '../../daos/unitofwork-offline.dao';
import { VariableEnvironnementUserService } from './variable-environnement-user.service';
import { VariableEnvironnementUserOnlineService } from './variable-environnement-user-online.service';
import { VariableEnvironnementUserOfflineService } from './variable-environnement-user-offline.service';

const VariableEnvironnementUserServiceFactory = (appService: AppService, httpClient: HttpClient, apiService: ApiService, unitOfWork: UnitOfWorkOfflineDao) =>
    appService.AppMode == APP_MODE.ONLINE_MODE ? 
    new VariableEnvironnementUserOnlineService(httpClient, apiService) : new VariableEnvironnementUserOfflineService();

export const VariableEnvironnementUserServiceProvider = { 
    provide: VariableEnvironnementUserService,
    useFactory: VariableEnvironnementUserServiceFactory,
    deps: [AppService, HttpClient, ApiService, UnitOfWorkOfflineDao]
};